import { FC } from "react";
import { t } from "@lingui/macro";
import { usePopularBrands } from "src/hooks/usePopularBrands";
import { BrandCarousel } from "src/molecules/BrandCarousel";
import { Box, Flex } from "@otrium/core";
import { BrandCardFallback } from "src/molecules/BrandCard";
import { times } from "lodash-es";
import { SEGMENT_PROMOTION_TYPE } from "src/segment";
import { useLingui } from "@lingui/react";
import { useFeatureFlags } from "src/hooks/useFeatureFlags";
import { useIsLoggedIn } from "src/hooks/useIsLoggedIn";

type genderId = "women" | "men" | "kids";

interface Props {
  genderId: genderId;
  excludeSlug?: string;
  localeGenderId: string;
  viewAllLink?: string;
  pageName?: string;
}

const PopularBrands: FC<Props> = ({
  localeGenderId,
  genderId,
  excludeSlug,
  viewAllLink,
  pageName,
}) => {
  const { i18n } = useLingui();
  const { error, data, loading } = usePopularBrands(
    localeGenderId,
    excludeSlug
  );
  const { enableGatedHomepage } = useFeatureFlags();
  const isLoggedIn = useIsLoggedIn();

  if (error && !data) {
    return null;
  }
  if (loading && !data) {
    return (
      <Flex width={1}>
        {times(4, (index: number) => (
          <Box mr={2} minWidth="auto" key={`fallback-brand-${index}`}>
            <BrandCardFallback />
          </Box>
        ))}
      </Flex>
    );
  }

  const isGated = !!enableGatedHomepage && !isLoggedIn;

  return (
    <>
      {data && genderId && (
        <BrandCarousel
          title={t(i18n)`Popular brands`}
          brands={data}
          genderId={genderId}
          slidesDesktop={3}
          slidesTablet={data.length > 3 ? 2.8 : 3}
          slidesMobile={1.5}
          headerLinkHref={viewAllLink}
          promotionType={SEGMENT_PROMOTION_TYPE.popularBrands}
          pageName={pageName}
          isGated={isGated}
          shopType={localeGenderId}
        />
      )}
    </>
  );
};

export default PopularBrands;
